import React from 'react'
import {
    Box,
    Button,
    LinearProgress,
    Typography,
    makeStyles,
    Theme,
} from '@material-ui/core'

import { useUser } from '../../../hooks/useUser'

const useStyles = makeStyles((theme: Theme) => ({
    copy: {
        marginBottom: theme.spacing(2),
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
    },
    progressLabel: {
        marginBottom: theme.spacing(1),
    },
}))

export interface DemoSeedStatus {
    enabled: boolean
    status: 'idle' | 'running' | 'completed' | 'failed'
    step: number
    step_total: number
    step_label: string
    error: string
    season_id: number | null
}

interface DemoSeasonChoiceProps {
    onYes: () => void
    onNo: () => void
    onClose: () => void
}

export const DemoSeasonChoice: React.FC<DemoSeasonChoiceProps> = ({
    onYes,
    onNo,
    onClose,
}) => {
    const classes = useStyles()
    const { rootUser } = useUser()
    const name = rootUser?.name?.trim()

    return (
        <Box>
            <Typography className={classes.copy} variant="h6">
                {name ? `Welcome, ${name}` : 'Welcome'}
            </Typography>
            <Typography className={classes.copy}>
                Do you want to create a leasing season with demo data?
            </Typography>
            <Box className={classes.actions}>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onNo}>No</Button>
                <Button color="primary" variant="contained" onClick={onYes}>
                    Yes
                </Button>
            </Box>
        </Box>
    )
}

export const DemoSeasonProgress: React.FC<{ status?: DemoSeedStatus }> = ({
    status,
}) => {
    const classes = useStyles()
    const step = status?.step ?? 0
    const total = status?.step_total || 8
    const label = status?.step_label || 'Starting'
    return (
        <Box>
            <Typography className={classes.progressLabel}>
                {label} ({Math.min(step, total)} of {total})
            </Typography>
            <LinearProgress
                variant="determinate"
                value={Math.round((Math.min(step, total) / total) * 100)}
            />
            {status?.status === 'failed' && status.error ? (
                <Typography color="error">{status.error}</Typography>
            ) : null}
        </Box>
    )
}
